// login.js
 
import { getService, postService } from '../api/service.js'
/**
 * name 登录
 * time 2021-09-07
 * param userName String 账号
 * param password String 密码
 * return String token
 * */
// 工作台
export const workePost = params => {
  return postService('/api/jfy/getSmsCount', params)
}
// 短信审核
export const notePost = params => {
  return postService('/api/jfy/getSmsTemplateList', params)
}
// 短信审核
export const noteExaminePost = params => {
  return postService('/api/jfy/getSmsTemplateInfo', params)
}
// 短信审核
export const noteExamineFailPost = params => {
  return postService('/api/jfy/checkSmsTemplate', params)
}
/**
 * name 登出
 * time 2021-09-07
 * */
export const codeGet = params => {
  return getService('/api/auth/getCaptcha', params)
}

// 工作台产品列表

export const getJfylistProduct = params => {
  return postService('api/jfy/getJfylistProduct', params)
}